import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faEdit, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

import { localDateString } from '../../../../components/helpers/datetranslate';

import { childrenAPI } from './actions';
import DateAcceptChange from './dateacceptchange';
import ChildInfo from '../../../kindergartens/detail/components/ChildrenCard';

import { sampleChildDataChildren } from './data/isampleChildInfo';

import ChildModal from '../ChildModalView/ChildModal';

import './showchildren.css';

const ShowChildren = () => {
// Состояния компонента
const [searchNumber, setSearchNumber] = useState('');
const [loading, setLoading] = useState(false);
const [message, setMessage] = useState('');
const [error, setError] = useState('');
const [listChildren, setListChildren] = useState([]);
const [openChildId, setOpenChildId] = useState('');
const [showChangeDate, setShowChangeDate] = useState(false);
const [dataChangeDate, setDataChangeDate] = useState({});
const [activeMenuIndex, setActiveMenuIndex] = useState(null);
const [showEditCard, setShowEditCard] = useState(false);
const [dataEditCard, setDataEditCard] = useState(null);
const [infoNotFound, setInfoNotFound] = useState(false);


const isSU = true;

// Поиск детей по номеру свидетельства
const getChildrenByNumber = async () => {
          setMessage('');
          setError('');
          setListChildren([]);
          setActiveMenuIndex(null);

          // Проверка на цифры
          if (!searchNumber.match(/^\d+$/)) {
            setMessage('Введіть тільки цифри');
            return;
          }

          setLoading(true);
          setInfoNotFound(false);

          try {
            const result = await childrenAPI.getChildrenByCertificate(searchNumber);
            
            if (result.success) {
              const sortedData = result.data.sort((a, b) => 
                a._id.birthDate.localeCompare(b._id.birthDate)
              );
              setInfoNotFound(sortedData.length < 1);
              setListChildren(sortedData);
            } else {
              setError(result.error || 'Помилка при отриманні даних');
            }
          } catch (err) {
            setError(`Помилка сервера: ${err.message}`);
          } finally {
            setLoading(false);
          }

};

const handleSearch = (e) => {
if (e) e.preventDefault();
getChildrenByNumber();
};

const handleKeyPress = (e) => {
if (e.key === 'Enter') {
handleSearch();
}
};

const toggleChild = (childId) => {
setOpenChildId(openChildId === childId ? '' : childId);
setActiveMenuIndex(null);
};

const handleOpenChangeDate = (data) => {
setDataChangeDate(data);
setShowChangeDate(true);
};

const handleCloseChangeDate = () => {
setShowChangeDate(false);
setDataChangeDate({});
};

const handleCloseChildInfo = () => {
setOpenChildId('');
};

const handleMenuToggle = (index) => {
setActiveMenuIndex(activeMenuIndex === index ? null : index);
};

const handleMenuClose = () => {
setActiveMenuIndex(null);
};

const handleActionSelect = (actionId, child) => {
if (actionId === 'edit') {
// Логика редактирования ребенка
setDataEditCard(child._id);
setShowEditCard(true);

// Здесь можно добавить вызов модального окна редактирования
} else if (actionId === 'transfer') {
// Логика перевода ребенка
// Здесь можно добавить логику перевода
}
setActiveMenuIndex(null);
};

// Компонент выпадающего меню действий
const ActionsMenu = ({ onActionSelect, onClose, child }) => {
const actions = [
  {
  id: 'edit',
  label: 'Переглянути',
  icon: faEdit
  },
  {
  id: 'transfer',
  label: 'Змінити дату зарахування',
  icon: faSignOutAlt
  }
];

return (
  <div className="actions-dropdown">
    {actions.map((action) => (
      <button
        key={action.id}
        className="dropdown-item d-flex align-items-center gap-2 p-2"
        onClick={() => onActionSelect(action.id, child)}
        style={{
          border: 'none',
          backgroundColor: 'transparent',
          width: '100%',
          textAlign: 'left',
          fontSize: '14px',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
      >
        <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
        <span style={{ color: '#212529' }}>{action.label}</span>
      </button>
    ))}
    
    <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
      <button
        className="btn btn-sm btn-outline-secondary w-100"
        onClick={onClose}
        style={{ fontSize: '12px' }}
      >
        Скасувати
      </button>
    </div>
  </div>
);

};

// Рендер строки с информацией о ребенке
const renderChildRow = (item, index) => {
  const statusElements = [];
  const childListId = Array.from(new Set(item.kg.map(el => el.idKg)));

  const childrenlist = childListId.map(el => {
    const name = item.kg.find(kg => kg.idKg === el);
    return { idKg: el, numberKg: name.numberKg };
  });

  // Определение статуса с использованием новых классов
  if (item.numGroupAll > item.numGroupEx) {
    statusElements.push(
      <span key="in-kg" className="status-badge badge-in-kg">В садочку</span>
    );
  }
  if (item.numGroupAll === item.numGroupEx && item.numGroupAll > 0) {
    statusElements.push(
      <span key="left" className="status-badge badge-left">Вибула</span>
    );
  }
  if (item.numGroupAll === item.numGroupEx && item.numGroupAll === 0) {
    statusElements.push(
      <span key="not-registered" className="status-badge badge-not-registered">Не оформлена</span>
    );
  }

  // Ссылки на детские сады с использованием новых классов
  item.kg.forEach((kg, kgIndex) => {
    statusElements.push(
      <a 
        key={`kg-${kgIndex}`}
        href={`/#/objpage/${kg.idKg}`} 
        className="status-badge badge-kg-link text-decoration-none"
        target="_blank"
        rel="noopener noreferrer"
      >
        {`${kg.numberKg}-${kg.nameKg || ''}; ${kg.group.number}-${kg.group.name || ''}`
          .replace('Заклад дошкільної освіти', '')
          .replace('Дошкільний навчальний заклад', '')
        }
      </a>
    );
  });

  return (
    <React.Fragment key={item._id._idCh}>
      <tr className={index % 2 === 0 ? 'table-light' : ''}>
        <td>
          <button 
            className="btn btn-link p-0 text-decoration-none border-0 bg-transparent"
            onClick={() => toggleChild(item._id._idCh)}
            style={{ color: '#0d6efd', fontWeight: '500' }}
          >
            {item._id.firstName}
          </button>
        </td>
        <td>{item._id.birthCertificate}</td>
        <td>{ localDateString(item._id.birthDate) }</td>
        <td>
          <div className="d-flex flex-column gap-1">
            {/* Первая строка - основные статусы */}
            <div className="d-flex flex-wrap gap-1">
              {statusElements.slice(0, 3).map((element, i) => 
                React.cloneElement(element, { key: `status-${i}` })
              )}
            </div>
            
            {/* Вторая строка - ссылки на детские сады (первые 3) */}
            {statusElements.length > 3 && (
              <div className="d-flex flex-wrap gap-1">
                {statusElements.slice(3, 6).map((element, i) => 
                  React.cloneElement(element, { key: `kg-${i}` })
                )}
              </div>
            )}
            
            {/* Третья строка - остальные ссылки */}
            {statusElements.length > 6 && (
              <div className="d-flex flex-wrap gap-1">
                {statusElements.slice(6).map((element, i) => 
                  React.cloneElement(element, { key: `kg-more-${i}` })
                )}
              </div>
            )}
            
            {/* Показать количество скрытых элементов если их много */}
            {statusElements.length > 9 && (
              <div className="text-muted small mt-1">
                +{statusElements.length - 9} ще...
              </div>
            )}
          </div>
        </td>
        <td className="text-end">
          <div className="actions-menu-container">
            <button
              className="btn btn-sm btn-link text-decoration-none p-0 border-0"
              onClick={() => handleMenuToggle(index)}
              style={{ color: '#0d6efd' }}
            >
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
            
            {activeMenuIndex === index && (
              <ActionsMenu 
                onActionSelect={handleActionSelect}
                onClose={handleMenuClose}
                child={item}
              />
            )}
          </div>
        </td>
      </tr>
      
      {openChildId === item._id._idCh && (
        <tr>
          <td colSpan="5" className="p-0">
            <div className="bg-light p-3">
              <ChildInfo 
                childId={item._id._idCh}
                isSU={isSU}
                isHeadDc={false}
                KinderGartenId={null}
                kindergartens={childrenlist}
                kindergartensGroup={{
                  number: (item.kg[0]?.group.number || ''),
                  name: (item.kg[0]?.group.name || ''),
                  children: [{}]
                }}
                parentFuncClose={handleCloseChildInfo}
                setDataChangeDate={setDataChangeDate}
                showCangeDate={() => handleOpenChangeDate({
                  group: {
                    _id: item.kg[0]?.idKg,
                    groups: {
                      children: { childId: item._id._idCh },
                      _id: item.kg[0]?.group._id
                    }
                  }
                })}
              />
            </div>
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};

return (
<div>
<DateAcceptChange data={dataChangeDate} show={showChangeDate} onHide={handleCloseChangeDate} />

<ChildModal isOpen={showEditCard} childId={dataEditCard?._idCh} onClose={()=>setShowEditCard(false)}/>   

  <div className="container-fluid">
    <div className="container">
      {/* Панель поиска */}
      <div className="search-panel">
        <div className="col-md-12">
          <form onSubmit={handleSearch}>
            <div className="row align-items-center">
              <div className="col-md-4">
                <label htmlFor="searchNumber" className="form-label">
                  Номер свідоцтва дитини:
                </label>
                <input 
                  id="searchNumber"
                  type="text" 
                  className="form-control"
                  value={searchNumber}
                  onChange={(e) => setSearchNumber(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Введіть номер свідоцтва"
                />
              </div>
              <div className="col-md-2">
                <button 
                  type="submit" 
                  className="btn btn-primary mt-4"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Пошук...
                    </>
                  ) : (
                    'Шукати'
                  )}
                </button>
              </div>
            </div>
          </form>

          {message && (
            <div className="alert alert-warning" role="alert">
              {message}
            </div>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
        </div>
      </div>

      {/* Результаты поиска */}
      <div className="row">
        <div className="col-md-12">
          {loading && (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Завантаження...</span>
              </div>
              <p className="mt-2">Зачекайте завантаження</p>
            </div>
          )}

          {!loading && listChildren.length > 0 && (
            <div className="showchildren-card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table showchildren-table align-middle mb-0">
                    <thead>
                      <tr>
                        <th scope="col">Ім'я дитини</th>
                        <th scope="col">Номер свідоцтва</th>
                        <th scope="col">Дата народження</th>
                        <th scope="col">Статус</th>
                        <th scope="col" className="text-end">Дії</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listChildren.map((item, index) => renderChildRow(item, index))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {infoNotFound && (
            <div className="alert alert-info text-center" role="alert">
              <h4>Не знайдено інформації</h4>
              <p className="mb-0">За вказаним номером свідоцтва дітей не знайдено</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
</div>

);
};

export default ShowChildren;